<div class="row page-head">
  <div class="col-xs-12 offset-sm-3 col-sm-5">
    <table>
      <tr>
        <td rowspan="2" width="83px" height="83px">
          <img [src]="img_src" height="60px" />
        </td>

        <td>
          <span id="header-title" class="profileName">{{ headerTitle }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span id="header-text1" class="profileGrade">{{ headerText1 }}</span>
          <span id="header-text2" class="profileGrade">{{ headerText2 }}</span>
        </td>
      </tr>
    </table>
  </div>
  <div class="col-xs-12 col-sm-4">
    <div id="general_search_table">
      <div id="general_search">
        <div class="row" *ngIf="ships">
          <form class="input-group" name="searchForm">
            <div class="col-sm-5 padding-0">
              <app-dropdown-select-control
                classes="form-control input-sm searhBoxheight"
                elementId="location"
                placeholder="Select Location (optional)"
                [searchTerm]="shipName"
                [source]="ships"
                (valueSelected)="selectShip($event)"
                (click)="showRecent = false"
              ></app-dropdown-select-control>
            </div>
            <div class="col-sm-5 padding-0">
              <input
                type="search"
                class="form-control"
                dropdown-toggle
                id="shipFirstParameter"
                placeholder="Merchant Search"
                [(ngModel)]="merchantName"
                name="merchantName"
                (click)="showRecent = !showRecent"
              />
            </div>
            <div class="col-sm-2 padding-0">
              <span id="search_button" class="input-group-btn">
                <button
                  class="btn btn-nc"
                  type="button"
                  (click)="searchMerchants()"
                  [disabled]="!shipName && !merchantName"
                >
                  <i class="fa fa-search"></i>
                </button>
              </span>
            </div>
          </form>
        </div>
        <div class="row">
          <div class="col-xl-12">
            <ul
              class="dropdown-menu"
              [ngStyle]="{ display: showRecent ? 'block' : 'none' }"
              id="recentSearchesList"
            >
              <li class="recentSearchHeader">RECENT SEARCHES</li>
              <li *ngIf="merchants.length > 0">
                <div class="searchResults">
                  <div
                    class="zeroPadding"
                    *ngFor="let merchantSearchResult of merchants"
                  >
                    <div
                      class="row searchResultsRow"
                      (click)="selectMerchant(merchantSearchResult)"
                    >
                      <div class="col-md-11 ">
                        <div class="searchResultName">
                          <div>{{ merchantSearchResult.descriptionLong }}</div>
                        </div>
                        <div class="searchResultDataName">
                          Location:
                          <span class="searchResultDataVal"
                            >{{ merchantSearchResult.shipName }}({{
                              merchantSearchResult.location
                            }})</span
                          >
                          | Card Number:
                          <span class="searchResultDataVal">{{
                            merchantSearchResult.cardNum | threeStars
                          }}</span>
                          | Type:
                          <span class="searchResultDataVal">{{
                            merchantSearchResult.type
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
